import { useTranslation } from 'react-i18next';
import { exerciseArt } from '../../exerciseArt.js';

const SOURCE_URL = 'https://github.com/everkinetic/data';
const LICENSE_URL = 'https://creativecommons.org/licenses/by-sa/4.0/';

/**
 * Anfangs- und Endstellung im Wechsel (bei „Bewegung reduzieren“ nebeneinander),
 * mit Namensnennung. Ohne Bild steht das ausdrücklich da — ein leerer Platz
 * sähe aus wie „braucht keins“.
 */
export function ExerciseArtFigure({
  catalogKey,
  name,
  small = false,
}: {
  catalogKey: string | null;
  name: string;
  small?: boolean;
}): React.JSX.Element {
  const { t } = useTranslation();
  const art = exerciseArt(catalogKey);
  if (!art) return <p className="text-xs text-ink-muted">{t('training.art.none')}</p>;

  return (
    <figure className="flex flex-col gap-1">
      <div
        role="img"
        aria-label={t('training.art.label', { name })}
        className={`kw-exercise-art ${small ? 'max-w-40' : 'max-w-64'}`}
      >
        <span style={{ '--art': `url("${art.start}")` } as React.CSSProperties} />
        <span style={{ '--art': `url("${art.end}")` } as React.CSSProperties} />
      </div>
      <figcaption className="text-xs text-ink-muted">
        {art.approx ? <span className="block">{t('training.art.approx')}</span> : null}
        {t('training.art.credit')}{' '}
        <a href={SOURCE_URL} target="_blank" rel="noreferrer noopener" className="underline">
          {t('training.art.source')}
        </a>
        ,{' '}
        <a href={LICENSE_URL} target="_blank" rel="noreferrer noopener" className="underline">
          {t('training.art.license')}
        </a>
        , {t('training.art.modified')}
      </figcaption>
    </figure>
  );
}
